<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  methods: {},
};
</script>

<style lang="scss" scoped>
$color: red;

div {
  font-size: 14px;
}
</style>
